export default __webpack_public_path__ + "static/media/ProcompLogo_magenta.bae45850.svg";